import { PX } from '../../../../contrib/ui';
export const EventHomeHeights = {
  ADDONSHEADER: 45 * PX,
  ADDPAYMENT: (355 + 28) * Math.max(PX, 0.8),
  BILLINGBASE: (210 + 28) * PX,
  CREDITCARD: (59 + 14) * PX,
  DISCLAIMER: 150 * PX,
  EVENTCHECKOUTBASE: (414 + 28) * PX,
  EVENTLOGIN: (308 + 28) * PX,
  EVENTMESSAGE: (425 + 28) * PX,
  EVENTMESSAGESENT: 300 * PX,
  EVENTSTATS: (60 + 28) * PX,
  EVENTSTATSREGISTERED: (120 + 28) * PX,
  EVENTSUCCESS: (415 + 28) * PX,
  EVENTWITHDRAW: (290 + 28) * PX // events stats height (see zeplin)
};
